import type { Lang } from '@/i18n';

const LOCALE: Record<Lang, string> = { pt: 'pt-BR', en: 'en-US' };

/** Money in its own currency: R$ 1.234,56 · US$ 12,00 · 12.50 USDT. */
export function money(amount: number | null | undefined, currency: string, lang: Lang): string {
    const n = Number(amount) || 0;
    const cur = String(currency || '').toUpperCase();
    const locale = LOCALE[lang] || 'pt-BR';
    if (cur === 'BRL' || cur === 'USD') {
        try {
            return new Intl.NumberFormat(locale, { style: 'currency', currency: cur, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
        } catch { /* fall through */ }
    }
    return `${new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 6 }).format(n)} ${cur}`.trim();
}

export function num(amount: number, lang: Lang, digits = 2): string {
    return new Intl.NumberFormat(LOCALE[lang] || 'pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: digits }).format(Number(amount) || 0);
}

export function dateTime(value: string | Date | null | undefined, lang: Lang): string {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return new Intl.DateTimeFormat(LOCALE[lang] || 'pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' }).format(d);
}

/** "12" / "12,5" / "12.50" → 12.5 ; anything else → NaN. */
export function parseAmountInput(text: string): number {
    const s = String(text || '').trim().replace(/\s/g, '');
    if (!s) return NaN;
    // "1.234,56" (pt) and "1,234.56" (en): the last separator is the decimal one.
    const lastComma = s.lastIndexOf(','), lastDot = s.lastIndexOf('.');
    let normalized = s;
    if (lastComma > -1 && lastDot > -1) {
        normalized = lastComma > lastDot ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, '');
    } else if (lastComma > -1) {
        normalized = s.replace(',', '.');
    }
    if (!/^\d+(\.\d{1,2})?$/.test(normalized)) return NaN;
    return Math.round(Number(normalized) * 100) / 100;
}

export function minutesLeft(until: string | null | undefined): number {
    if (!until) return 0;
    return Math.max(0, Math.ceil((new Date(until).getTime() - Date.now()) / 60000));
}
